import { render, staticRenderFns } from "./ReadingChart.vue?vue&type=template&id=2aa2a87a&scoped=true&"
import script from "./ReadingChart.vue?vue&type=script&lang=ts&"
export * from "./ReadingChart.vue?vue&type=script&lang=ts&"
import style0 from "./ReadingChart.vue?vue&type=style&index=0&id=2aa2a87a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa2a87a",
  null
  
)

export default component.exports